export const environment = {
  production: false,
  hostname: 'qa.osparts.toyota.com',

  REDIRECT_URL: 'https://qa.osparts.toyota.com/',

  CLIENT_ID: '44a22c00-69af-4ee5-b0e7-a8997235c0eb',
  TENANT_ID: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef',

  ccsApiUrl: 'https://alb.ccsdev.toyota.com/os-parts/',
  ccsApiBasicAuth: 'Basic ' + btoa('CCS:78fa095d-3f4c-48b1-ad50-e24c31d5cf35'),

  fluctuationAllowanceKey: 'zkuoqoHcI382Vi2pfsGbk46vKVlirL0G2zZsFhdP',
  fluctuationAllowanceUrl: 'https://iidzy2mvkc.execute-api.us-west-2.amazonaws.com/qa/api/v1/fluctuationallowance',

  bulkAdjustmentKey: 'xHfP5OW0XL9jymfTiRhu12DSrZvE56wm6LBe7dU4',
  bulkAdjustmentUrl: 'https://8rjfgytv59.execute-api.us-west-2.amazonaws.com/qa/api/v1/bulkadjustment',

  rundownKey: 'liewZXlh1b3PzUH4sgiOM1F3gcv3Xu3D97QLeVPv',
  rundownUrl: 'https://0mfgtzy4a8.execute-api.us-west-2.amazonaws.com/qa/api/v1/rundown',

  orderForecastKey: 'kpME0caBCm9xSnLLwW66t6BpsGh59MQU305LWCYD',
  orderForecastUrl: 'https://k2knfle55f.execute-api.us-west-2.amazonaws.com/qa/api/v1/orderforecast',

  lookupKey: 'SuTu4nwZHj509T6JoXd6Q7JixnmO4ZKb3Xf2KSu4',
  lookupUrl: 'https://dtpd393s65.execute-api.us-west-2.amazonaws.com/qa/api/v1/lookup',

  getsudoKey: 'LrYkI9t9Tu3DSBiKm9y0o6zNmLoX7MVE99Bx1PHT',
  getsudoUrl: 'https://5x32mdj6m1.execute-api.us-west-2.amazonaws.com/qa/api/v1/getsudo',

  // This is in Setup service lambda with different url
  getsudoDatesUrl: 'https://tktzpy70pj.execute-api.us-west-2.amazonaws.com/qa/api/v1/getsudo',

  setupKey: 'SuTu4nwZHj509T6JoXd6Q7JixnmO4ZKb3Xf2KSu4',
  setupUrl: 'https://tktzpy70pj.execute-api.us-west-2.amazonaws.com/qa/api/v1/setup',

  adjustmentEnquiryKey: 'X9HtqDYiCl4n25z5resMs9tPxV9jbK7N9gc23Uyc',
  adjustmentEnquiryUrl: 'https://krmqc4mm10.execute-api.us-west-2.amazonaws.com/qa/api/v1/adjustment',

  // pipe urls

  ospLookupUrl: 'https://obc8rcouz1.execute-api.us-west-2.amazonaws.com/qa/api/v1/lookup',
  ospLookupKey: 'Byhg5XOcjC3kq0ttPxwSN5KFH8mpqkbv2jCSDGRb',

  partStatusUrl: 'https://2e2phzc8qa.execute-api.us-west-2.amazonaws.com/qa/api/v1/getpartstatus',
  partStatusKey: 'rlg1d5Zxcu7M1G4nqPsvZ5nV1j7o6qec1AUhiKZB',

  partMaintenance: 'https://yzo4810udc.execute-api.us-west-2.amazonaws.com/qa/api/v1/partMaintenance',
  partMaintenanceKey: 'saXKQV66AV3j5dhvU8OxS4yHumhMHTsbeTeWPRcg',

  ospSealVerificationUrl: 'https://geyayspbl8.execute-api.us-west-2.amazonaws.com/qa/api/v1/sealVerification',
  ospSealVerificationKey: 'KLnNqIkUouaAXLlNtr2Po82NsIzfKOHj88klwcHW',
  //PIE lambda urls

  sendToPieData: `https://internalapi.pie.subprod.toyota.com/tnso/update-container-info`,

  airOrderUrl: 'https://2kss4r7bc8.execute-api.us-west-2.amazonaws.com/qa/api/v1/airfreight',
  airOrderKey: 'BwFz1k45dj7YFxofk1syV2iQDTVH4Usa8bBiAe5c',

  moduleStockingPaceUrl: 'https://nvog6oad3f.execute-api.us-west-2.amazonaws.com/qa/api/v1/stockingPace',
  stockingPaceKey:'ROzPDZQV3U4W1X6SyE7XU6LTwV0Dn3Fm6idZEjpI',

  moduleStockingUrl: 'https://luytmi2qh9.execute-api.us-west-2.amazonaws.com/qa/api/v1/modulestocking',
  moduleStockingKey: 'a0t5JCCO1N3gpDuOf9QPd85E2TtY3ECB56qu944T',

  prodProgressUrl: 'https://b1gu90hgvb.execute-api.us-west-2.amazonaws.com/qa/api/v1/prodprogress',
  prodProgressKey: 'a1GcHMpHGN1GOIM8ez4TV1B8oeGxeAUl5MVA9YoL',
  
  uvrKey:'pEcgJBpLQB8CN72z7UeYA9wldHS82m3Zd1uuPx1d',
  uvrUrl:'https://l5pc05bws9.execute-api.us-west-2.amazonaws.com/qa/api/v1/invuvr',

  partsinventoryUrl: 'https://34o59x5s34.execute-api.us-west-2.amazonaws.com/qa/api/v1/partsinventory',
  partsinventoryKey: 'u732cjawsZ4FTOv4wiatp7rWChhcr7km4CFSGCqU',


  procurementUrl: 'https://b1gu90hgvb.execute-api.us-west-2.amazonaws.com/qa/api/v1/procurement',
  devanningHistoryURL:'https://nvog6oad3f.execute-api.us-west-2.amazonaws.com/qa/api/v1/inventory'

};
